import { render, staticRenderFns } from "./price_configurator.vue?vue&type=template&id=667a53fc&scoped=true&lang=html"
import script from "./price_configurator.vue?vue&type=script&lang=js"
export * from "./price_configurator.vue?vue&type=script&lang=js"
import style0 from "./price_configurator.vue?vue&type=style&index=0&id=667a53fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667a53fc",
  null
  
)

export default component.exports